export default "__VITE_ASSET__Dff1qqn6__"